import { createSlice } from "@reduxjs/toolkit";
import menus from "../../pages/Settings/UserManagement/ModuleAccess/json/menu";

let initialState = menus;

const moduleAccessSlice = createSlice({
  name: "moduleAccess",
  initialState: initialState,
  reducers: {
    setModuleAccess: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});
export const { setModuleAccess } = moduleAccessSlice.actions;
export default moduleAccessSlice.reducer;
